/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

import Swiper from './../libs/swiper';
import {is_breakpoint_up, scroll_to, config, debounce, raf, swiperLazy} from "../helpers/functions";
import axios from 'axios';
import App from '../helpers/app';
import Cookies from 'js-cookie';
import {sendEcommerceTags} from "../helpers/datalayer";
import Headroom from "headroom.js";

$(function(){
    let $formRequest = null;
    function initOfferEvents() {
        let $section = $('.section-home-offers');
        if(!$section.length){
            return;
        }

        $section.find('form [name]:not([name*="slider"])').each(function(){
            let name = $(this).attr('name').substring($(this).attr('name').indexOf('[')+1, $(this).attr('name').indexOf(']'));
            let value = $(this).val();

            $(document).trigger('param:init', ['glowna', name, value, $(this).is('[type="checkbox"]') || $(this).is('[type="radio"]') ? $(this).is(':checked') : true]);
        });

        $section.find('form [name]:not([name*="slider"])').change(function(){
            let name = $(this).attr('name').substring($(this).attr('name').indexOf('[')+1, $(this).attr('name').indexOf(']'));
            let value = $(this).val();

            $(document).trigger('param:change', ['glowna', name, value, $(this).is('[type="checkbox"]') || $(this).is('[type="radio"]') ? $(this).is(':checked') : true]);
        });

        $section.find('form input[name]').not('[type="hidden"]:not(.range-value)').change(function(){
            let $bannerSwiper = $('.section-home-banner .banner-container')[0].swiper;
            if($bannerSwiper){
                $bannerSwiper.autoplay.stop();
            }
        });

        let $form = $section.find('form');
        $form.find('[name*="body_type"]:checked').prop('checked', false);
        $form.submit(function (e) {
            let checked = $form.find('[name*="body_type"]:checked');
            if(checked.length===1){
                let first = checked.first();
                if(first.attr('name').indexOf('body_type')!==-1 && first.val()==='furgon_group'){
                    let path = $.address.pathNames();
                    if(path[0]==='dostawcze'){
                        return false;
                    }
                    path.unshift('dostawcze');
                    $.address.autoUpdate(false);
                    $.address.path(path.join('/'));
                    window.location.href = $.address.value();
                    return false;
                }
                if(first.attr('name').indexOf('body_type')!==-1 && first.val()==='motocykl'){
                    $form.find('[name*="finance_type"][value="leasing"]').prop('checked', true);
                }
            }

            e.preventDefault();

            if ($formRequest) {
                $formRequest.cancel();
            }

            $formRequest = axios.CancelToken.source();

            axios.post('/carsell/utils/slider-items', $(this).serialize(), { cancelToken: $formRequest.token, params: {multisite: window.multisite} })
                .then(function(response){
                    if(response.data.redirect){
                        window.location.href = response.data.redirect;
                        return;
                    }

                    raf(function (){
                        $section.find('.offer-container').empty().append(response.data.page.html);
                        App.init($section.find('.offer-container'));
                        sendEcommerceTags($section.find('.offer-container .offer-list .offer-item'));
                    });

                    initAggregateLoadingEvent();
                })
                .catch(function(){

                });
        });
    }

    initOfferEvents();

    let $firstVisit = !Cookies.get('base_param_monthly_price');
    function initBannerEvents(){
        function bannerSliderChange(){
            let $slide = $section.find('.swiper-slide-active');

            $form.find('[name="SearchOfferForm[slider]"]').val($slide.data('id')).change();

            raf(function (){
                $('body')
                    .removeClassStartsWith('config-slider-')
                    .addClass('config-slider-'+$slide.data('id'));

                $('body')
                    .removeClassStartsWith('slider-theme-')
                    .addClass('slider-theme-'+$slide.data('theme'));

                $('body')
                    .removeClassStartsWith('slider-promo-')
                    .addClass($slide.data('promo') ? 'slider-'+$slide.data('promo') : '');
            });

            let $clientType = $slide.data('client-type');
            let $product = $slide.data('product');
            let $monthlyPrice = $slide.data('monthly-price');

            if($clientType && $clientTypeGroup.length && $form.find('[name="SearchOfferForm[offer_type]"]:checked').val()!=$clientType && $firstVisit){
                $clientTypeGroup.find('[value="'+$clientType+'"]').parent().get(0).click();
            }
            if($product && $productGroup.length && $form.find('[name="SearchOfferForm[finance_type]"]:checked').val()!=$product && $firstVisit){
                $productGroup.find('[value="'+$product+'"]').parent().get(0).click();
            }
            if($monthlyPrice && $priceSlider.noUiSlider && $form.find('[name="SearchOfferForm[monthly_price]"]').val()!=$monthlyPrice && $firstVisit){
                $priceSlider.noUiSlider.set($monthlyPrice);
            }

            $form.submit();
        }

        let $section = $('.section-home-banner');
        if(!$section.length){
            return;
        }

        let $sectionOffers = $('.section-home-offers');
        let $productGroup = $sectionOffers.find('.group-finance .btn-group');
        let $clientTypeGroup = $sectionOffers.find('.group-offer .btn-group');
        let $priceSlider = $sectionOffers.find('.group-price').find('.range-slider')[0];
        let $form = $sectionOffers.find('form');

        $section.find('.search').click(function (e) {
            e.preventDefault();

            $('header .search-toggle').click();
        });

        $section.find('.banner-item[data-clickable="1"], .banner-item .action .btn').click(function(e){
            e.preventDefault();
            e.stopPropagation();

            let $banner = !$(this).hasClass('banner-item') ? $(this).closest('.banner-item') : $(this);

            dataLayer.push({
                'ecommerce': {
                    'promoView': {
                        'promotions': [{
                            'id': $banner.data('id'),
                            'name': $banner.find('.title').text(),
                            'creative': 'slider',
                            'position': $banner.data('swiper-slide-index')+1
                        }]
                    }
                }
            });

            window.location.href = $banner.data('more');
        });

        let monthlyPriceSlide = $section.find('.swiper-slide[data-monthly-price="'+$form.find('[name="SearchOfferForm[monthly_price]"]').val()+'"]');
        let defaultSlide = $section.find('.swiper-slide[data-default="1"]');
        let initialSlide = defaultSlide.length ? defaultSlide.index() : (monthlyPriceSlide.length ? monthlyPriceSlide.index() : 0);

        let $bannerSwiper = new Swiper('.section-home-banner .banner-container', {
            loop: true,
            autoplay: config('homepage_slider_autoplay', 1)==='1' ? {
                delay: parseInt(config('homepage_slider_autoplay_timeout', 15)) * 1000,
            } : false,
            slidesPerView: 1,
            initialSlide: initialSlide,
            spaceBetween: 0,
            slidesOffsetAfter: 0,
            pagination: {
                el: '.banner-pagination',
                clickable: true,
                bulletClass: 'page',
                bulletActiveClass: 'active',
            },
            navigation: {
                nextEl: '.banner-nav .next',
                prevEl: '.banner-nav .prev',
            },
            on: {
                init: bannerSliderChange,
                slideChangeTransitionEnd: bannerSliderChange,
            }
        });
    }

    initBannerEvents();

    function initAggregateSwiperEvent(){
        let swiperElements = $('.aggregate-preview .aggregate-container');
        swiperElements.each(function(){
            let swiperElement = $(this);
            let swiperInstance = $(this)[0].swiper;

            if(is_breakpoint_up('lg')){
                if ( swiperInstance ){
                    swiperInstance.destroy( true, true );
                }

                swiperElement.removeClass('swiper-container');
                swiperElement.find('.aggregate-list').removeClass('swiper-wrapper');
                swiperElement.find('.aggregate-item').removeClass('swiper-slide');
            }else{
                swiperElement.addClass('swiper-container');
                swiperElement.find('.aggregate-list').addClass('swiper-wrapper');
                swiperElement.find('.aggregate-item').addClass('swiper-slide');

                if( !swiperInstance ){
                    new Swiper(swiperElement[0], {
                        breakpoints: {
                            0: {
                                slidesPerView: 1,
                                spaceBetween: 0,
                                slidesOffsetAfter: -45,
                            },
                            576: {
                                slidesPerView: 2,
                                spaceBetween: 0,
                                slidesOffsetAfter: -45,
                            },
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 0,
                                slidesOffsetAfter: -60,
                            },
                        },
                    });
                }
            }
        });
    }

    function initAggregateLoadingEvent() {
        let $model = [];
        $model.push($('.section-home-offers [name="SearchOfferForm[offer_type]"]:checked').val());
        $model.push($('.section-home-offers [name="SearchOfferForm[finance_type]"]:checked').val());

        let $aggregates = $('.aggregate-preview:not([data-aggregate-model="'+$model.join('-')+'"])');
        if($aggregates.length){
            let $top = $(document).scrollTop();

            $aggregates.each(function(){
                let $aggregate = $(this);
                let $treshold = $aggregate.hasClass('is-initialized') ? 500 : 500;
                let $windowHeight = $(window).height();
                let $offset = $aggregate.offset().top;

                if($offset-$treshold-$windowHeight<$top){
                    $aggregate.addClass('is-initialized');
                    $aggregate.attr('data-aggregate-model', $model.join('-'));

                    App.loader.init($aggregate);

                    axios.post('/carsell/utils/aggregate-preview', $('.section-home-offers form').serialize(), { params: {id: $aggregate.data('aggregate-id'), type: $aggregate.data('aggregate-type')} })
                        .then(function(response){
                            $aggregate.find('section').remove();
                            $aggregate.append(response.data.page.html);

                            initAggregateSwiperEvent();

                            App.init($aggregate);
                            App.loader.end($aggregate);
                        });
                }
            });
        }
    }

    function initAggregateEvents(){
        initAggregateSwiperEvent();
        $(window).on('resize', function(){
            initAggregateSwiperEvent();
        });

        initAggregateLoadingEvent();
        $(window).on('scroll resize', function(){
            initAggregateLoadingEvent();
        });
    }

    initAggregateEvents();

    function initVideoEvents(){
        let $section = $('.section-home-video');
        if(!$section.length){
            return;
        }

        new Swiper('.section-home-video .video-container', {
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    slidesOffsetAfter: -45,
                },
                576: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                    slidesOffsetAfter: -45,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                    slidesOffsetAfter: -60,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                    slidesOffsetAfter: 0,
                },
            },
        });
    }

    swiperLazy('video', initVideoEvents);

    function initTestimonialsEvents(){
        let $section = $('.section-home-testimonials');
        if(!$section.length){
            return;
        }

        new Swiper('.section-home-testimonials .testimonial-container', {
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    slidesOffsetAfter: -85,
                },
                576: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                    slidesOffsetAfter: -85,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                    slidesOffsetAfter: -120,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                    slidesOffsetAfter: 0,
                },
                1280: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                    slidesOffsetAfter: 0,
                }
            },
            pagination: {
                el: '.section-home-testimonials .testimonial-pagination',
                clickable: true,
                bulletClass: 'page',
                bulletActiveClass: 'active',
            },
        });
    }

    swiperLazy('testimonials', initTestimonialsEvents);

    function initMediaEvents(){
        let $section = $('.section-home-media');
        if(!$section.length){
            return;
        }

        new Swiper('.section-home-media .media-container', {
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    slidesOffsetAfter: -85,
                },
                576: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                    slidesOffsetAfter: -85,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                    slidesOffsetAfter: -120,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                    slidesOffsetAfter: 0,
                },
                1280: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                    slidesOffsetAfter: 0,
                }
            },
            pagination: {
                el: '.section-home-media .media-pagination',
                clickable: true,
                bulletClass: 'page',
                bulletActiveClass: 'active',
            },
        });
    }

    swiperLazy('media', initMediaEvents);

    function initBrandSwiperEvent() {
        let $section = $('.section-home-brands');
        if(!$section.length){
            return;
        }

        let swiperElement = $section.find('.brand-list-container');
        let swiperInstance = swiperElement[0].swiper;

        if(is_breakpoint_up('lg') && swiperInstance){
            swiperInstance.destroy( true, true );
        }else if(!is_breakpoint_up('lg') && !swiperInstance){
            new Swiper(swiperElement[0], {
                breakpoints: {
                    0: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                        slidesOffsetAfter: -60,
                        slidesOffsetBefore: 15,
                    },
                    576: {
                        slidesPerView: 3,
                        spaceBetween: 10,
                        slidesOffsetAfter: -45,
                        slidesOffsetBefore: 15,
                    },
                    768: {
                        slidesPerView: 4,
                        spaceBetween: 10,
                        slidesOffsetAfter: -60,
                        slidesOffsetBefore: 30,
                    },
                },
            });
        }
    }

    function initBrandEvents() {
        let $section = $('.section-home-brands');
        if(!$section.length){
            return;
        }

        $section.find('.section-more-button .btn').click(function () {
            $section.find('.brand-list-container').addClass('show-all');
        });

        initBrandSwiperEvent();
        $(window).on('resize', function(){
            initBrandSwiperEvent();
        });
    }

    initBrandEvents();
});

